import axios from 'axios'
import Dialog from '../../components/dialog'

export function getData() {
  return axios
    .get('/api/html/SkyworthQ71')
    .then(({ data }) => {
      if (data.resultCode === '0') {
        if (window.sessionStorage) {
          sessionStorage.setItem('message', data.result)
        }
        return JSON.parse(data.result).message
      }
    })
    .catch((error) => {
      console.log(error)
      Dialog('加载失败，请刷新重试~').show()
    })
}

export function getPageData(city) {
  return new Promise((resolve, reject) => {
    let message = sessionStorage.getItem('message')
    if (city) {
      if (message) {
        message = JSON.parse(message).message
        console.log(city);
        console.log(getCityData(message, city).form);
        resolve(getCityData(message, city).form)
      } else {
        getData().then((result) => {
          resolve(getCityData(result, city).form)
        })
      }
    } else {
      message = JSON.parse(message).message
      resolve(message)
    }
  })
}

function getCityData(data, name) {
  return data.find((item) => item.name === name)
}
